var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg5Star(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 159,
    height: 30,
    viewBox: "0 0 159 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_369)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.8125 0H0V30H29.8125V0Z",
    fill: "#00B67A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1094 0H32.2969V30H62.1094V0Z",
    fill: "#00B67A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4062 0H64.5938V30H94.4062V0Z",
    fill: "#00B67A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.703 0H96.8906V30H126.703V0Z",
    fill: "#00B67A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159 0H129.188V30H159V0Z",
    fill: "#00B67A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9031 20.2187L19.4371 19.0625L21.3314 24.9375L14.9031 20.2187ZM25.3375 12.625H17.3564L14.9031 5.0625L12.4498 12.625H4.46875L10.9281 17.3125L8.4748 24.875L14.9342 20.1875L18.9092 17.3125L25.3375 12.625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2 20.2187L51.734 19.0625L53.6283 24.9375L47.2 20.2187ZM57.6344 12.625H49.6533L47.2 5.0625L44.7467 12.625H36.7656L43.225 17.3125L40.7717 24.875L47.2311 20.1875L51.2061 17.3125L57.6344 12.625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.4969 20.2187L84.0309 19.0625L85.9252 24.9375L79.4969 20.2187ZM89.9313 12.625H81.9502L79.4969 5.0625L77.0436 12.625H69.0625L75.5219 17.3125L73.0686 24.875L79.5279 20.1875L83.5029 17.3125L89.9313 12.625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.794 20.2187L116.328 19.0625L118.222 24.9375L111.794 20.2187ZM122.228 12.625H114.247L111.794 5.0625L109.34 12.625H101.359L107.819 17.3125L105.365 24.875L111.825 20.1875L115.8 17.3125L122.228 12.625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.091 20.2187L148.625 19.0625L150.519 24.9375L144.091 20.2187ZM154.525 12.625H146.544L144.091 5.0625L141.637 12.625H133.656L140.116 17.3125L137.662 24.875L144.122 20.1875L148.097 17.3125L154.525 12.625Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_369"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 159,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5Star);
export default __webpack_public_path__ + "static/media/5star.db0ea4b2864a0ec7764145cacc1d22c7.svg";
export { ForwardRef as ReactComponent };